/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portalsignin_Passkey_HelpInputs */

const en_portalsignin_passkey_help = /** @type {(inputs: Portalsignin_Passkey_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use a passkey saved on this device.`)
};

/** @type {(inputs: Portalsignin_Passkey_HelpInputs) => LocalizedString} */
const ar_portalsignin_passkey_help = en_portalsignin_passkey_help;

/** @type {(inputs: Portalsignin_Passkey_HelpInputs) => LocalizedString} */
const he_portalsignin_passkey_help = en_portalsignin_passkey_help;

/** @type {(inputs: Portalsignin_Passkey_HelpInputs) => LocalizedString} */
const ur_portalsignin_passkey_help = en_portalsignin_passkey_help;

/** @type {(inputs: Portalsignin_Passkey_HelpInputs) => LocalizedString} */
const es_portalsignin_passkey_help = en_portalsignin_passkey_help;

/** @type {(inputs: Portalsignin_Passkey_HelpInputs) => LocalizedString} */
const fr_portalsignin_passkey_help = en_portalsignin_passkey_help;

/** @type {(inputs: Portalsignin_Passkey_HelpInputs) => LocalizedString} */
const de_portalsignin_passkey_help = en_portalsignin_passkey_help;

/** @type {(inputs: Portalsignin_Passkey_HelpInputs) => LocalizedString} */
const pt_portalsignin_passkey_help = en_portalsignin_passkey_help;

/** @type {(inputs: Portalsignin_Passkey_HelpInputs) => LocalizedString} */
const hi_portalsignin_passkey_help = en_portalsignin_passkey_help;

/** @type {(inputs: Portalsignin_Passkey_HelpInputs) => LocalizedString} */
const bn_portalsignin_passkey_help = en_portalsignin_passkey_help;

/**
* | output |
* | --- |
* | "Use a passkey saved on this device." |
*
* @param {Portalsignin_Passkey_HelpInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const portalsignin_passkey_help = /** @type {((inputs?: Portalsignin_Passkey_HelpInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portalsignin_Passkey_HelpInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_portalsignin_passkey_help(inputs)
	if (locale === "he") return he_portalsignin_passkey_help(inputs)
	if (locale === "ur") return ur_portalsignin_passkey_help(inputs)
	if (locale === "es") return es_portalsignin_passkey_help(inputs)
	if (locale === "fr") return fr_portalsignin_passkey_help(inputs)
	if (locale === "de") return de_portalsignin_passkey_help(inputs)
	if (locale === "pt") return pt_portalsignin_passkey_help(inputs)
	if (locale === "hi") return hi_portalsignin_passkey_help(inputs)
	if (locale === "bn") return bn_portalsignin_passkey_help(inputs)
	return /** @type {LocalizedString} */ ("Use a passkey saved on this device.")
});